import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function OrderCancel() {
  return (
    <div className="min-h-screen bg-app text-app flex flex-col items-center justify-center p-6 text-center">
      <div className="h-14 w-14 rounded-full bg-red-500/15 ring-4 ring-red-500/20 flex items-center justify-center mb-4">
        <XCircle className="h-7 w-7 text-red-400" strokeWidth={2.5} />
      </div>
      <div className="text-[24px] font-extrabold tracking-tight">Payment cancelled</div>
      <p className="text-muted-app text-sm mt-2 max-w-xs">
        Your order was not placed. You can go back and try again.
      </p>
      <Link
        to="/tnb-order"
        data-testid="cancel-back-to-order"
        className="pressable mt-6 bg-accent-app text-accent-fg bg-accent-hover-app rounded-full px-6 py-3 font-extrabold uppercase tracking-wider"
      >
        Back to Order
      </Link>
    </div>
  );
}
